/**
 * @fileoverview gRPC-Web generated client stub for user_endpoint
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v6.32.1
// source: user.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as user_pb from './user_pb'; // proto import: "user.proto"


export class UserEndpointClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorAdd = new grpcWeb.MethodDescriptor(
    '/user_endpoint.UserEndpoint/Add',
    grpcWeb.MethodType.UNARY,
    user_pb.AddUserRequest,
    user_pb.AddUserResponse,
    (request: user_pb.AddUserRequest) => {
      return request.serializeBinary();
    },
    user_pb.AddUserResponse.deserializeBinary
  );

  add(
    request: user_pb.AddUserRequest,
    metadata?: grpcWeb.Metadata | null): Promise<user_pb.AddUserResponse>;

  add(
    request: user_pb.AddUserRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: user_pb.AddUserResponse) => void): grpcWeb.ClientReadableStream<user_pb.AddUserResponse>;

  add(
    request: user_pb.AddUserRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: user_pb.AddUserResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/user_endpoint.UserEndpoint/Add',
        request,
        metadata || {},
        this.methodDescriptorAdd,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/user_endpoint.UserEndpoint/Add',
    request,
    metadata || {},
    this.methodDescriptorAdd);
  }

  methodDescriptorUpdate = new grpcWeb.MethodDescriptor(
    '/user_endpoint.UserEndpoint/Update',
    grpcWeb.MethodType.UNARY,
    user_pb.UpdateUserRequest,
    user_pb.UpdateUserResponse,
    (request: user_pb.UpdateUserRequest) => {
      return request.serializeBinary();
    },
    user_pb.UpdateUserResponse.deserializeBinary
  );

  update(
    request: user_pb.UpdateUserRequest,
    metadata?: grpcWeb.Metadata | null): Promise<user_pb.UpdateUserResponse>;

  update(
    request: user_pb.UpdateUserRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: user_pb.UpdateUserResponse) => void): grpcWeb.ClientReadableStream<user_pb.UpdateUserResponse>;

  update(
    request: user_pb.UpdateUserRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: user_pb.UpdateUserResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/user_endpoint.UserEndpoint/Update',
        request,
        metadata || {},
        this.methodDescriptorUpdate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/user_endpoint.UserEndpoint/Update',
    request,
    metadata || {},
    this.methodDescriptorUpdate);
  }

  methodDescriptorUpdateActivity = new grpcWeb.MethodDescriptor(
    '/user_endpoint.UserEndpoint/UpdateActivity',
    grpcWeb.MethodType.UNARY,
    user_pb.UpdateUserActivityRequest,
    user_pb.UpdateUserActivityResponse,
    (request: user_pb.UpdateUserActivityRequest) => {
      return request.serializeBinary();
    },
    user_pb.UpdateUserActivityResponse.deserializeBinary
  );

  updateActivity(
    request: user_pb.UpdateUserActivityRequest,
    metadata?: grpcWeb.Metadata | null): Promise<user_pb.UpdateUserActivityResponse>;

  updateActivity(
    request: user_pb.UpdateUserActivityRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: user_pb.UpdateUserActivityResponse) => void): grpcWeb.ClientReadableStream<user_pb.UpdateUserActivityResponse>;

  updateActivity(
    request: user_pb.UpdateUserActivityRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: user_pb.UpdateUserActivityResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/user_endpoint.UserEndpoint/UpdateActivity',
        request,
        metadata || {},
        this.methodDescriptorUpdateActivity,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/user_endpoint.UserEndpoint/UpdateActivity',
    request,
    metadata || {},
    this.methodDescriptorUpdateActivity);
  }

  methodDescriptorUpdateConfirmationState = new grpcWeb.MethodDescriptor(
    '/user_endpoint.UserEndpoint/UpdateConfirmationState',
    grpcWeb.MethodType.UNARY,
    user_pb.UpdateUserConfirmationStateRequest,
    user_pb.UpdateUserConfirmationStateResponse,
    (request: user_pb.UpdateUserConfirmationStateRequest) => {
      return request.serializeBinary();
    },
    user_pb.UpdateUserConfirmationStateResponse.deserializeBinary
  );

  updateConfirmationState(
    request: user_pb.UpdateUserConfirmationStateRequest,
    metadata?: grpcWeb.Metadata | null): Promise<user_pb.UpdateUserConfirmationStateResponse>;

  updateConfirmationState(
    request: user_pb.UpdateUserConfirmationStateRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: user_pb.UpdateUserConfirmationStateResponse) => void): grpcWeb.ClientReadableStream<user_pb.UpdateUserConfirmationStateResponse>;

  updateConfirmationState(
    request: user_pb.UpdateUserConfirmationStateRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: user_pb.UpdateUserConfirmationStateResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/user_endpoint.UserEndpoint/UpdateConfirmationState',
        request,
        metadata || {},
        this.methodDescriptorUpdateConfirmationState,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/user_endpoint.UserEndpoint/UpdateConfirmationState',
    request,
    metadata || {},
    this.methodDescriptorUpdateConfirmationState);
  }

  methodDescriptorUpdateAccountSecurity = new grpcWeb.MethodDescriptor(
    '/user_endpoint.UserEndpoint/UpdateAccountSecurity',
    grpcWeb.MethodType.UNARY,
    user_pb.UpdateAccountSecurityRequest,
    user_pb.UpdateAccountSecurityResponse,
    (request: user_pb.UpdateAccountSecurityRequest) => {
      return request.serializeBinary();
    },
    user_pb.UpdateAccountSecurityResponse.deserializeBinary
  );

  updateAccountSecurity(
    request: user_pb.UpdateAccountSecurityRequest,
    metadata?: grpcWeb.Metadata | null): Promise<user_pb.UpdateAccountSecurityResponse>;

  updateAccountSecurity(
    request: user_pb.UpdateAccountSecurityRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: user_pb.UpdateAccountSecurityResponse) => void): grpcWeb.ClientReadableStream<user_pb.UpdateAccountSecurityResponse>;

  updateAccountSecurity(
    request: user_pb.UpdateAccountSecurityRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: user_pb.UpdateAccountSecurityResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/user_endpoint.UserEndpoint/UpdateAccountSecurity',
        request,
        metadata || {},
        this.methodDescriptorUpdateAccountSecurity,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/user_endpoint.UserEndpoint/UpdateAccountSecurity',
    request,
    metadata || {},
    this.methodDescriptorUpdateAccountSecurity);
  }

  methodDescriptorUpdateUsername = new grpcWeb.MethodDescriptor(
    '/user_endpoint.UserEndpoint/UpdateUsername',
    grpcWeb.MethodType.UNARY,
    user_pb.UpdateUsernameRequest,
    user_pb.UpdateUsernameResponse,
    (request: user_pb.UpdateUsernameRequest) => {
      return request.serializeBinary();
    },
    user_pb.UpdateUsernameResponse.deserializeBinary
  );

  updateUsername(
    request: user_pb.UpdateUsernameRequest,
    metadata?: grpcWeb.Metadata | null): Promise<user_pb.UpdateUsernameResponse>;

  updateUsername(
    request: user_pb.UpdateUsernameRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: user_pb.UpdateUsernameResponse) => void): grpcWeb.ClientReadableStream<user_pb.UpdateUsernameResponse>;

  updateUsername(
    request: user_pb.UpdateUsernameRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: user_pb.UpdateUsernameResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/user_endpoint.UserEndpoint/UpdateUsername',
        request,
        metadata || {},
        this.methodDescriptorUpdateUsername,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/user_endpoint.UserEndpoint/UpdateUsername',
    request,
    metadata || {},
    this.methodDescriptorUpdateUsername);
  }

  methodDescriptorGetUsers = new grpcWeb.MethodDescriptor(
    '/user_endpoint.UserEndpoint/GetUsers',
    grpcWeb.MethodType.UNARY,
    user_pb.GetUsersRequest,
    user_pb.GetUsersResponse,
    (request: user_pb.GetUsersRequest) => {
      return request.serializeBinary();
    },
    user_pb.GetUsersResponse.deserializeBinary
  );

  getUsers(
    request: user_pb.GetUsersRequest,
    metadata?: grpcWeb.Metadata | null): Promise<user_pb.GetUsersResponse>;

  getUsers(
    request: user_pb.GetUsersRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: user_pb.GetUsersResponse) => void): grpcWeb.ClientReadableStream<user_pb.GetUsersResponse>;

  getUsers(
    request: user_pb.GetUsersRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: user_pb.GetUsersResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/user_endpoint.UserEndpoint/GetUsers',
        request,
        metadata || {},
        this.methodDescriptorGetUsers,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/user_endpoint.UserEndpoint/GetUsers',
    request,
    metadata || {},
    this.methodDescriptorGetUsers);
  }

  methodDescriptorGetUser = new grpcWeb.MethodDescriptor(
    '/user_endpoint.UserEndpoint/GetUser',
    grpcWeb.MethodType.UNARY,
    user_pb.GetUserRequest,
    user_pb.GetUserResponse,
    (request: user_pb.GetUserRequest) => {
      return request.serializeBinary();
    },
    user_pb.GetUserResponse.deserializeBinary
  );

  getUser(
    request: user_pb.GetUserRequest,
    metadata?: grpcWeb.Metadata | null): Promise<user_pb.GetUserResponse>;

  getUser(
    request: user_pb.GetUserRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: user_pb.GetUserResponse) => void): grpcWeb.ClientReadableStream<user_pb.GetUserResponse>;

  getUser(
    request: user_pb.GetUserRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: user_pb.GetUserResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/user_endpoint.UserEndpoint/GetUser',
        request,
        metadata || {},
        this.methodDescriptorGetUser,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/user_endpoint.UserEndpoint/GetUser',
    request,
    metadata || {},
    this.methodDescriptorGetUser);
  }

  methodDescriptorResetUserPassword = new grpcWeb.MethodDescriptor(
    '/user_endpoint.UserEndpoint/ResetUserPassword',
    grpcWeb.MethodType.UNARY,
    user_pb.ResetUserPasswordRequest,
    user_pb.ResetUserPasswordResponse,
    (request: user_pb.ResetUserPasswordRequest) => {
      return request.serializeBinary();
    },
    user_pb.ResetUserPasswordResponse.deserializeBinary
  );

  resetUserPassword(
    request: user_pb.ResetUserPasswordRequest,
    metadata?: grpcWeb.Metadata | null): Promise<user_pb.ResetUserPasswordResponse>;

  resetUserPassword(
    request: user_pb.ResetUserPasswordRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: user_pb.ResetUserPasswordResponse) => void): grpcWeb.ClientReadableStream<user_pb.ResetUserPasswordResponse>;

  resetUserPassword(
    request: user_pb.ResetUserPasswordRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: user_pb.ResetUserPasswordResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/user_endpoint.UserEndpoint/ResetUserPassword',
        request,
        metadata || {},
        this.methodDescriptorResetUserPassword,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/user_endpoint.UserEndpoint/ResetUserPassword',
    request,
    metadata || {},
    this.methodDescriptorResetUserPassword);
  }

}

